import { curry } from 'ramda';
import { IAppState } from '../../../redux';
import { IFormattedPackage } from '../../../redux/reducers';
import { selectActiveService } from '../selectActiveService';
import { formatPackageName } from './formatPackageName';

export const selectFormattedPackages = curry((isMobile: boolean, state: IAppState): IFormattedPackage[] => {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return [];
  }

  const {
    publishOptions: { packageIds, packages },
  } = selectedService;

  return packageIds.map(packageId => {
    const servicePackage = packages[packageId];

    return {
      value: servicePackage.id,
      label: formatPackageName(servicePackage, isMobile),
    };
  });
});
